import { __assign } from "tslib";
import dayjs from 'dayjs';
import dayjsLocale from 'dayjs/locale/zh-cn';
import localeData from 'dayjs/plugin/localeData';
import badMutable from 'dayjs/plugin/badMutable';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';
dayjs.extend(localeData);
dayjs.extend(badMutable);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(weekOfYear);
dayjs.locale('zh-cn', __assign(__assign({}, dayjsLocale), { weekStart: 1 }));
export default dayjs;
